<template>

	<div v-if="track" class="py-3">

		<div class="mb-3 text-muted">
			Track: {{ track.title }}<br>
			Album: {{ ( track.album && track.album.name ? track.album.name : '---------' ) }}<br>
			Composer: {{ track.composer || '---------' }}
		</div>

		<form method="post" v-on:submit="validateForm">

			<div class="form-group">

				<label for="licenseTrackYourNameInput">
					Your Name:
				</label>

			<input class="form-control" id="licenseTrackYourNameInput" placeholder="John Doe" v-model="name"  v-bind:class="{ 'is-invalid': attemptSubmit && missingName }" />

				<div class="invalid-feedback">
					Name field is required.
				</div>

			</div>

			<div class="form-group">

				<label for="licenseTrackYourEmailInput">
					Your Email:
				</label>

				<input type="email" class="form-control" id="licenseTrackYourEmailInput" placeholder="me@example.com" v-model="email"  v-bind:class="{ 'is-invalid': attemptSubmit && missingEmail }" />

				<div class="invalid-feedback">
					Email field is required.
				</div>

			</div>

			<div class="form-group">

				<label for="licenseTrackYourCommentsInput">
					Additional Comments:
				</label>

				<textarea class="form-control" id="licenseTrackYourCommentsInput" placeholder="Additional Comments (optional)" v-model="notes" cols="30" rows="7" />

			</div>

			<input type="submit" value="Request" class="btn btn-raised btn-danger btn-xl font-weight-semibold"/>

		</form>

	</div>

</template>

<script>

	import Vue from 'vue';
	import { playerService } from '../player-service';

	export default Vue.component(
		'license-track',
		{

			data: function () {

				return {

					track: null,
                    email: typeof window.authenticatedUserEmail == 'boolean' ? null : window.authenticatedUserEmail,
                    name: typeof window.authenticatedUserName == 'boolean' ? null : window.authenticatedUserName,
					notes: null,
					attemptSubmit: false,

				};

			},

			computed: {

				missingName: function () {
					return ( !this.name || this.name === '' );
				},

				missingEmail: function () {
					return ( !this.email || this.email === '' );
				}

			},

			mounted: function () {

                playerService.$on( 'user-updated', () => {

                    this.email = typeof window.authenticatedUserEmail == 'boolean' ? null : window.authenticatedUserEmail;
					this.name = typeof window.authenticatedUserName == 'boolean' ? null : window.authenticatedUserName;

                } );

				playerService.$on(
					'open-license-track',
					( track ) => {

						// Update curr track for modal + reset selected project.
						this.track = track;

						// Open the modal.
						window.webpackOpenBsModalWorkaround( '#licenseTrackModal' );

					}
				);

			},

			methods: {

				validateForm: function(event) {

					this.attemptSubmit = true;
					event.preventDefault();

					if( !this.missingName && !this.missingEmail ) {

						this.requestLicense();

					}

				},

				requestLicense: function() {

					playerService.requestTrackLicense( this.track, this.name, this.email, this.notes );

				}

			},

		}
	);

</script>
